import {Directive, ElementRef, HostBinding, Input, OnInit} from '@angular/core';
export class LayerDirective implements OnInit {

   
  depth: string;
/**
 * @param {?} element
 */
constructor(element: ElementRef) {
  }
/**
 * @return {?}
 */
ngOnInit(): void {
    // depth is required in parallax.js
    if (!this.depth) {
      throw new Error('depth is required');
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[parallaxLayer]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'depth': [{ type: Input },{ type: HostBinding, args: ['attr.data-depth', ] },],
};
}

function LayerDirective_tsickle_Closure_declarations() {
/** @type {?} */
LayerDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LayerDirective.ctorParameters;
/** @type {?} */
LayerDirective.propDecorators;
/** @type {?} */
LayerDirective.prototype.depth;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
